var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search_widget" }, [
    _c("h3", { staticClass: "search_header" }, [
      _vm._v("이 카페 "),
      _c("em", { staticClass: "search_keyword" }, [
        _vm._v(_vm._s(_vm.config.searchKeyword))
      ]),
      _vm._v(" 관련글")
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "search_list" },
      _vm._l(_vm.articles, function(article, index) {
        return _c("search-item", {
          key: index,
          attrs: { article: article, config: _vm.config }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }